
  var _styles = {
  "coupon-card-single": {
    "display": "flex",
    "flexDirection": "column",
    "position": "relative",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.21333rem",
    "marginBottom": "0.32rem",
    "overflow": "visible",
    "height": "2.02667rem",
    "width": "8.93333rem"
  },
  "coupon-content": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "paddingTop": "0.21333rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.42667rem",
    "paddingLeft": 0,
    "borderRadius": "0.21333rem"
  },
  "left-section": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "2.8rem"
  },
  "middle-section": {
    "display": "flex",
    "flexDirection": "column",
    "flex": 1,
    "marginLeft": "0.08rem",
    "marginRight": 0,
    "marginTop": "0.29333rem"
  },
  "prize-name": {
    "fontSize": "0.42667rem",
    "color": "rgb(51,51,51)",
    "fontWeight": "500",
    "marginBottom": "0.10667rem"
  },
  "expire-time": {
    "fontSize": "0.32rem",
    "color": "rgb(153,153,153)"
  },
  "button-wrapper": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": "0.64rem",
    "width": "2.13333rem",
    "height": "0.8rem",
    "marginTop": "0.45333rem"
  },
  "button-text": {
    "fontSize": "0.37333rem",
    "color": "rgb(255,255,255)",
    "fontWeight": "500"
  }
};



  module.exports = _styles;
  